/** Whether the person asked the system to cut down on motion; without `matchMedia` (old browsers, tests) the answer is no. */
export function prefersReducedMotion(): boolean {
  return typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
